import { Outlet } from "react-router";
import { usePageTracking } from "../hooks/usePageTracking";

/**
 * Wraps all routes so every SPA navigation sends a GA4 `page_view` with `page_path`
 * (initial load included). Must live inside the router tree.
 */
export function RouteAnalyticsLayout() {
  usePageTracking();
  return <Outlet />;
}
